export const WEATHER_COORDINATE_DECIMAL_PLACES = 2;

function canonicalizeCoordinate(value, minimum, maximum) {
  const coordinate = Number(value);

  if (
    !Number.isFinite(coordinate) ||
    coordinate < minimum ||
    coordinate > maximum
  ) {
    return null;
  }

  return coordinate.toFixed(WEATHER_COORDINATE_DECIMAL_PLACES);
}

export function getWeatherGridCoordinates(lat, long) {
  const latitude = canonicalizeCoordinate(lat, -90, 90);
  const longitude = canonicalizeCoordinate(long, -180, 180);

  return latitude == null || longitude == null
    ? null
    : { lat: latitude, long: longitude };
}

export function buildWeatherApiPath(lat, long) {
  const coordinates = getWeatherGridCoordinates(lat, long);

  return coordinates
    ? `/api/weather/${coordinates.lat}/${coordinates.long}`
    : null;
}
